export const GET_FEE_COLLECTION_MONTHS_YEARS = 'GET_FEE_COLLECTION_MONTHS_YEARS'
export const GET_FEE_PARTICULARS = 'GET_FEE_PARTICULARS'
export const GET_FEE_BANK_ACCOUNTS = 'GET_FEE_BANK_ACCOUNTS'
export const GENERATE_ROYALTY_INVOICE = 'GENERATE_ROYALTY_INVOICE'
export const FETCH_DUPLICATE_INVOICE = 'FETCH_DUPLICATE_INVOICE'
export const GET_ROYALTY_INVOICES = 'GET_ROYALTY_INVOICES'
export const PRINT_ROYALTY_PDF = 'PRINT_ROYALTY_PDF'
export const GET_SINGLE_INVOICE = 'GET_SINGLE_INVOICE'
export const UPDATE_ROYALTY_INVOICE = 'UPDATE_ROYALTY_INVOICE'
export const DELETE_ROYALTY_INVOICE = 'DELETE_ROYALTY_INVOICE'
export const CLEAR_ROYALTY_INVOICE = 'CLEAR_ROYALTY_INVOICE'
export const GET_ROYALTY_SETTINGS = 'GET_ROYALTY_SETTINGS'
export const UPDATE_ROYALTY_SETTINGS = 'UPDATE_ROYALTY_SETTINGS'
